import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaTimes, FaTimesCircle } from 'react-icons/fa'

import { Tooltip, Animation, PopOut } from 'components'
import { TagOptions } from 'features'

import classes from './Tag.module.css'

const defaultStyle = {
    borderRadius: '10px',
    backgroundColor: 'var(--secondary-color)',
    color: 'white',
    border: '1px solid transparent',
    padding: '0.1rem 0.5rem',
    margin: '0 0.5rem 0 0',
    fontSize: '0.8rem',
    fontWeight: 'normal',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '2rem',
    cursor: 'auto',
}

const Container = styled.div`
    border-radius: ${props => props.style.borderRadius};
    background-color: ${props => props.style.backgroundColor};
    color: ${props => props.style.color};
    border: ${props => props.style.border};
    padding: ${props => props.style.padding};
    margin: ${props => props.style.margin};
    font-size: ${props => props.style.fontSize};
    font-weight: ${props => props.style.fontWeight};
    border-radius: ${props => props.style.borderRadius};
    display: ${props => props.style.display};
    justify-content: ${props => props.style.justifyContent};
    align-items: ${props => props.style.alignItems};
    min-width: ${props => props.style.minWidth};
    cursor: ${props => props.style.cursor};
    line-height: 0.9rem;
    // overflow: hidden;
    // :hover {
    //     filter: brightness(1.2);
    // }
`

const Icon = styled.div`
    color: #F5F5F5;
    opacity: 0.8;
    font-size: var(--icon-size);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.2rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`


const Tag = props => {
    const {
        tooltip,
        styles,
        label,
        icon,
        onDelete,
        deleteIcon,
        id,
        contextMenu,
        tag
    } = props;

    let updatedStyle = Object.assign({}, defaultStyle, styles)
    // const content = <Container style={updatedStyle}>
    //                     {icon}
    //                     <div style={{maxWidth: '8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{label}</div>
    //                     {onDelete ? <Icon onClick={onDelete}>{deleteIcon || <FaTimesCircle/>}</Icon> : null}
    //                 </Container>
    const content = contextMenu ?
    <PopOut trigger='leftClick' element={<TagOptions tag={tag} tagID={id}/>}>
        <Container style={updatedStyle}>
            {icon}
            <div style={{maxWidth: '8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{label}</div>
            {onDelete ? <Icon onClick={onDelete}>{deleteIcon || <FaTimesCircle/>}</Icon> : null}
        </Container>
    </PopOut>
    : <Container style={updatedStyle}>
        {icon}
        <div style={{maxWidth: '8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{label}</div>
        {onDelete ? <Icon onClick={onDelete}>{deleteIcon || <FaTimesCircle/>}</Icon> : null}
    </Container>
    

    if(tooltip){
        return (
            <Tooltip title={tooltip} placement='bottom' arrow={true}>
                {content}
            </Tooltip>
        )
    } else {
        return (
            <div>{content}</div>
        )
    }
}

export default Tag;

Tag.propTypes = {
    tooltip: PropTypes.string,
    style: PropTypes.object,
    label: PropTypes.string.isRequired,
    icon: PropTypes.element,
    onDelete: PropTypes.func,
    deleteIcon: PropTypes.element
}